
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/freemium",
      function () {
        return require("private-next-pages/getting-started/freemium.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/freemium"])
      });
    }
  